import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { CompartmentListInitialState, CompartmentListLoad } from './compartment-list.actions';
import { CompartmentListState, CompartmentListStateModel } from './compartment-list.state';
import { CompartmentListSearchCriteria } from '../models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { HubItemFacade } from '../../hub/item/hub-item.facade';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CompartmentListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<CompartmentListStateModel> = this.store.select(CompartmentListState.getState);
  loaded$: Observable<boolean> = this.store.select(CompartmentListState.getLoaded);

  constructor(
    private store: Store,
    private hubItemFacade: HubItemFacade,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
  ) {}

  loadAll(): void {
    combineLatest([
      this.hubItemFacade.hubId$,
      this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.Compartments),
    ])
      .pipe(take(1))
      .subscribe(([hubId, searchCriteria]: [number, CompartmentListSearchCriteria]) => {
        this.store.dispatch(new CompartmentListLoad({ hubId, searchCriteria }));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new CompartmentListInitialState());
  }
}
